// extracted by mini-css-extract-plugin
module.exports =  {"left":"osvGvvckMrauo3A8jQVO","right":"Wm2uoEOIl8WNt0gIL115","alert":"msJldd8Z4faNTcAPpWdg","root":"LTZIMwoF6DWsuOGEmNEd"};